// Reporta errores JS no capturados a Google Cloud Error Reporting. Port
// 1:1 de errorReporter.coffee. La API key va al querystring de la
// petición a clouderrorreporting.googleapis.com — su seguridad depende
// de restricciones HTTP referrer + API scope en la consola de GCP.
//
// El flag `caught` evita reportes duplicados: si una primera excepción
// dispara una cascada (p.ej. componentes de React en bucle), enviamos
// sólo la primera.

import ErrorStackParser from "error-stack-parser";
import { getFdPublicConfig } from "./window";

let caught = false;

interface ErrorPayload {
  serviceContext: { service: string };
  context: {
    httpRequest: { userAgent: string; url: string };
  };
  message: string;
}

function sendErrorPayload(payload: ErrorPayload) {
  const cfg = getFdPublicConfig();
  const url = `https://clouderrorreporting.googleapis.com/v1beta1/projects/${cfg.GOOGLE_CLOUD_PROJECT_ID}/events:report?key=${cfg.GOOGLE_CLOUD_API_KEY}`;
  const xhr = new XMLHttpRequest();
  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
  xhr.send(JSON.stringify(payload));
}

export function report(err: Error | string | null | undefined) {
  if (err == null) return;
  const payload: ErrorPayload = {
    serviceContext: { service: "web-keycloak" },
    context: {
      httpRequest: {
        userAgent: window.navigator.userAgent,
        url: window.location.href,
      },
    },
    message: "",
  };

  let firstFrameIndex = 0;
  let errObj: Error;
  if (typeof err === "string") {
    try {
      throw new Error(err);
    } catch (e) {
      errObj = e as Error;
    }
    // El primer frame al usar report() siempre es esta lib.
    firstFrameIndex = 1;
  } else {
    errObj = err;
  }

  let stack: ReturnType<typeof ErrorStackParser.parse> = [];
  try {
    stack = ErrorStackParser.parse(errObj);
  } catch {
    stack = [];
  }
  payload.message = errObj.toString();
  for (let i = firstFrameIndex; i < stack.length; i++) {
    const s = stack[i];
    payload.message += "\n";
    payload.message += `    at ${s.getFunctionName?.()} (${s.getFileName?.()}:${s.getLineNumber?.()}:${s.getColumnNumber?.()})`;
  }

  sendErrorPayload(payload);
}

function handleWindowError(
  message: string | Event,
  source?: string,
  lineno?: number,
  colno?: number,
  error?: Error,
): boolean {
  if (caught) return false;
  caught = true;
  if (error) {
    report(error);
  } else {
    report(
      `message: ${String(message)}, source: ${source}, lineno: ${lineno}, colno: ${colno}`,
    );
  }
  return false;
}

export function init() {
  window.onerror = handleWindowError;
}
